import { GeographicalAgencyType } from "@/codegen/openapi2";

import { GeographicalAgencyTypeOptionByType } from "../../cells/geographical-agency-type-options";
import { GeographicalAgencyTypeTag } from "../../cells/geographical-agency-type-tag";

type RequestedTypeCellProps = {
  requestedType: GeographicalAgencyType | null;
};
export const RequestedTypeCell = ({ requestedType }: RequestedTypeCellProps) =>
  requestedType ? (
    <GeographicalAgencyTypeTag
      geographicalAgencyTypeValue={GeographicalAgencyTypeOptionByType[requestedType]}
    />
  ) : (
    "-"
  );
